// extracted by mini-css-extract-plugin
module.exports = {"formSection":"form-section_formSection__3Hu3h","title":"form-section_title__2mmgd","content":"form-section_content__eJI0L"};